"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.optional = void 0;
exports.optional = {
    $fn: [
        "x",
        {
            $grammar: {
                "optional:zero": [],
                "optional:one": [{ head: "x" }],
            },
        },
    ],
};
//# sourceMappingURL=optional.js.map